import { LockIcon } from "lucide-react";
import { useTranslations } from "translations";
import { Tooltip } from "../tooltip/tooltip";

// HeroUI date pickers reserve the `end` slot for the calendar toggle. Render the
// secure lock in `startContent` with `order-last` so it sits beside the calendar
// icon without replacing it.
export function DateSecureIndicator() {
  const translations = useTranslations();
  const label = translations.patient.encryptedFieldSecure;

  return (
    <Tooltip content={label}>
      <span
        aria-label={label}
        className="flex size-4 shrink-0 items-center justify-center text-gray-900 [&>svg]:block"
      >
        <LockIcon size={16} />
      </span>
    </Tooltip>
  );
}
